import {SearchBar, Button, TextHero} from "../polaris";
import { useState, useEffect, useRef } from "react";
import {isPWA, requestPermission } from "../services/pwa";

export default function Header({ onLoad }) {

  const [browser,setBrowser] = useState(false)

  const fileInputRef = useRef(null);

  const handleOpenFile = () => {
    fileInputRef.current?.click();
  };

  const handleChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (event) => {
      onLoad(event.target.result); // base64
    };
    reader.readAsDataURL(file);
  };

  const Logout = () => {
    localStorage.removeItem("token-mail");
    window.location.reload();
  }

  useEffect(() => {
    const pwa = isPWA();
    setBrowser(pwa);
  },[]);

  return (
    <div className="flex items-center px-2 py-3 shadow sticky gap-1 top-0 z-10"
        style={{
          backgroundColor: "rgb(20, 20, 20)",
          color: "rgb(142, 142, 142)",
          zIndex: "1000"
        }}
      >
        
      {/* Logo */}

      <div className="mr-auto flex px-2">
        <div className="flex items-center self-center gap-4 text-xs text-center">
          <input ref={fileInputRef} type="file" accept="image/*" onChange={handleChange} className="hidden"/>
          <div>
            <TextHero size="25px">Adobe</TextHero>
            <TextHero size="15px">Turbosify</TextHero>
          </div>
          <div className="w-[60px] text-[#8e8e8e] cursor-pointer" onClick={handleOpenFile}>
            Open file 
          </div>
          <div className="w-[80px] text-[#8e8e8e]">
            Save as
          </div>
          <div className="w-[80px] text-[#8e8e8e]">
            Filters
          </div>
          <div className="w-[80px] text-[#8e8e8e]">
            History
          </div>
          <div>
            <SearchBar/>
          </div>

        </div>
        
      </div>

      <div className="w-full flex relative">
      {/* Search bar */}
      {/* <div className="mr-auto md:mx-auto max-w-3xl flex flex-1 justify-center px-2">
        <div className="w-3/4 md:w-full mr-auto md:mx-auto">
          <SearchBar placeholder="Type anything ..."/>
        </div>
      </div> */}

      {/* Actions */}
      <div className="flex items-center absolute right-0 self-center">
        <Button>Contact</Button>
        <svg onClick={ () => requestPermission(browser)} fill="rgb(135, 135, 135)" className="ml-1 md:ml-2 cursor-pointer w-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fill-rule="evenodd" d="m7.252 14.424-2.446-.281c-1.855-.213-2.38-2.659-.778-3.616l.065-.038a2.887 2.887 0 0 0 1.407-2.48v-.509a4.5 4.5 0 0 1 9 0v.51c0 1.016.535 1.958 1.408 2.479l.065.038c1.602.957 1.076 3.403-.778 3.616l-2.543.292v.365a2.7 2.7 0 0 1-5.4 0v-.376Zm3.9.076h-2.4v.3a1.2 1.2 0 0 0 2.4 0v-.3Zm-3.152-1.5h4l3.024-.348a.452.452 0 0 0 .18-.837l-.065-.038a4.414 4.414 0 0 1-.747-.562 4.387 4.387 0 0 1-1.392-3.205v-.51a3 3 0 0 0-6 0v.51a4.387 4.387 0 0 1-2.138 3.767l-.065.038a.452.452 0 0 0 .18.838l3.023.347Z"/></svg>
      </div>

      </div> 
      
    </div>
  );
}
